import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getFestiveHeroCopy, isNavratriDasaraSeason } from '../../../views/home/festive/navratriSeason';
import { getDiwaliCopy, isDiwaliSeason } from '../../../views/home/festive/diwaliSeason';

const HeroSection = () => {
    const festive = isNavratriDasaraSeason();
    const diwali = !festive && isDiwaliSeason();
    const festiveCopy = festive ? getFestiveHeroCopy() : diwali ? getDiwaliCopy() : null;

    return (
        <Box
            sx={{
                position: "absolute",
                left: { xs: "1.25rem", md: "2.5rem" },
                right: { xs: "1.25rem", md: "auto" },
                transform: "none",
                textAlign: "left",
                color: "#fff",
                width: { xs: "auto", md: "min(620px, 70%)" },
                px: 2,
                zIndex: 2,
                top: {
                    xs: "26%",
                    sm: "32%",
                    md: "18%"
                },
                textShadow: "0 10px 25px rgba(0,0,0,0.7)"
            }}
        >
            <Typography
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    background: festive || diwali ? "rgba(42, 16, 18, 0.45)" : "rgba(255,255,255,0.1)",
                    border: festive || diwali ? "1px solid rgba(246, 226, 168, 0.55)" : "1px solid rgba(255,255,255,0.22)",
                    backdropFilter: "blur(8px)",
                    py: "0.32rem",
                    px: "0.875rem",
                    borderRadius: "2rem",
                    fontSize: "0.76rem",
                    fontWeight: 500,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    color: festive || diwali ? "#F6E2A8" : "rgba(255,255,255,0.9)",
                    mb: "0.08rem",
                    fontFamily: '"DM Sans", Arial, sans-serif',
                }}
            >
                {festiveCopy ? festiveCopy.eyebrow : "Your home. Professionally managed."}
            </Typography>
            <Typography
                variant="subtitle1"
                fontWeight={300}
                fontSize={{ xs: "1.67rem", sm: "2.16rem", md: "3.46rem" }}
                sx={{ fontFamily: '"Playfair Display", Georgia, serif', mt: 0, opacity: 0.98, maxWidth: 760, lineHeight: 1.12, letterSpacing: "-0.02em", fontWeight: 500 }}
            >
                Homes that feel
                <br />
                like yours.
                <br />
                <Box component="span" sx={{ color: "#FFBD59", fontWeight: 700, fontStyle: "italic" }}>
                    Managed for you.
                </Box>
            </Typography>
            {festiveCopy ? (
                <Typography
                    sx={{
                        mt: 1.25,
                        maxWidth: 480,
                        fontFamily: '"DM Sans", Arial, sans-serif',
                        fontSize: { xs: "0.92rem", md: "1.05rem" },
                        fontWeight: 500,
                        lineHeight: 1.45,
                        color: "rgba(255,248,239,0.92)",
                        textShadow: "0 8px 18px rgba(0,0,0,0.55)",
                    }}
                >
                    {festiveCopy.line}
                </Typography>
            ) : null}
        </Box>
    );
};

export default HeroSection;
